export default __webpack_public_path__ + "./fonts/help.7abd8f5e.svg";